<form class="example-form">
	<mat-form-field class="example-full-width">
		<input matInput name="searchWord" [placeholder]="placeholder" (keyup)="keyUp($event)" [(ngModel)]="searchWord" />
	</mat-form-field>
	<app-check-box
		[subAreasOptions]="renderList"
		[enableScroll]="enableScroll"
		[attrLabel]="attrLabel"
		[checkBoxAll]="checkBoxAll"
		[allSelect]="allSelect"
		(selectEvt)="emit($event)"
		[allPhase]="allPhase"
		[onlyView]="onlyView"
		[hideSelected]="hideSelected"
	></app-check-box>
</form>
